import React from 'react';
import { SettingsPanel } from '../SettingsPanel';
import { Wrapper, ContentContainer, Header, Title, SettingsPanelContainer } from './styles';
import useChatbot from 'hooks/useChatbot';
import utils from 'utils';

interface EmbeddedProps {
  loading: boolean;
  renderContent: () => React.ReactNode;
}

const Embedded: React.FC<EmbeddedProps> = ({ loading, renderContent }) => {
  const { hasChatbotAdvancedConfig } = useChatbot();
  const t = utils.intl.useTranslator();

  return (
    <Wrapper hasPanel={hasChatbotAdvancedConfig}>
      <ContentContainer>
        <Header>
          <Title>{utils.app.textTranslated('chatbotTitle', t, 'Do you need some help?')}</Title>
        </Header>
        {renderContent()}
      </ContentContainer>

      {hasChatbotAdvancedConfig && (
        <SettingsPanelContainer>
          <SettingsPanel loading={loading} />
        </SettingsPanelContainer>
      )}
    </Wrapper>
  );
};

export default Embedded;
